import { createWithEqualityFn } from "zustand/traditional";
import { shallow } from "zustand/shallow";
// import { immer } from "zustand/middleware/immer";
import { persist, createJSONStorage } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import devDebug from "../Helpers/debug";
import default_mapdata from "../Assets/Mapdata/default_mapdata.json";
import i18n from "i18next";
import { defaultStrategies } from "../Services/strategies/strategyConstants";
import idbKeyvalAdapter from "./1_utility";



// define the initial state
const initialState = {
  defaultStrategies: { ...defaultStrategies },
};
const currentAppVersionFromEnv = Number(import.meta.env.VITE_VERSION);

export const useDefaultStrategyStore = createWithEqualityFn(
  persist(
    immer((set, get) => ({
      ...initialState,
      compileDefaultStrategies: (existingStrategies) =>
        set((state) => {
          let nuts = [];
          for (let id of Object.keys(existingStrategies)) {
            for (let nut of existingStrategies[id].nuts) {
              for (let id of Object.keys(default_mapdata))
                if ((id.includes(nut) || id === nut) && !nuts.includes(nut)) {
                  nuts.push(nut);
                }
            }
          }
          state.defaultStrategies["dashboard_logged_in"].all.nuts = nuts;
          //TODO: figure out why this hack is needed, when the names should be populated by strategyConstants.js
          state.defaultStrategies["dashboard_logged_in"].all.name =
            i18n.t("All Strategies");
          state.defaultStrategies["tender_awards"].all.name =
            i18n.t("All Strategies");
          state.defaultStrategies["awards_search"].all.name =
            i18n.t("All Strategies");
          state.defaultStrategies["awards_search"].market.name =
            i18n.t("Market");
          state.defaultStrategies["companies_search"].all.name =
            i18n.t("All Strategies");
          state.defaultStrategies["companies_search"].market.name =
            i18n.t("Market");
          state.defaultStrategies["dashboard_anonymous"].anonymous.name =
            i18n.t("All Strategies");
          state.defaultStrategies["search"].all.name = i18n.t("All Strategies");
        }),

      resetState: () => {
        useDefaultStrategyStore.persist.clearStorage();
        set(initialState);
      },
    })),
    {
      name: "defaultStrategies",
      storage: createJSONStorage(() => idbKeyvalAdapter),
      version: currentAppVersionFromEnv,
      migrate: (persistedState, storedVersion) => {
        devDebug(
          `[defaultStrategyStore Migrate] Called! Stored: ${storedVersion} (type: ${typeof storedVersion}), App: ${currentAppVersionFromEnv} (type: ${typeof currentAppVersionFromEnv})`
        );
        if (storedVersion !== currentAppVersionFromEnv) {
          devDebug('[defaultStrategyStore Migrate] Versions differ. Resetting to initialState.');
          return initialState;
        }
        if (persistedState === null || persistedState === undefined) {
          devDebug('[defaultStrategyStore Migrate] Persisted state is null/undefined despite version match. Resetting.');
          return initialState;
        }
        devDebug('[defaultStrategyStore Migrate] Versions same. Using persisted state.');
        return persistedState;
      },
      // merge: (persistedState, currentState) => {
      //   devDebug('[defaultStrategyStore Merge] Merging state...');
      //   if (typeof persistedState !== 'object' || persistedState === null) {
      //     devDebug('[defaultStrategyStore Merge] Persisted state is not an object, returning current state or initialState.');
      //     return initialState;
      //   }
      //   return mergeDeepLeft(persistedState, currentState);
      // },
      onRehydrateStorage: (state) => {
        devDebug(`[defaultStrategyStore onRehydrateStorage] Attempting rehydration...`);
        return (hydratedState, error) => {
          if (error) {
            console.error(
              `[defaultStrategyStore] Failed to rehydrate store!`,
              error
            );
            devDebug(
              `[defaultStrategyStore] Error during rehydration. Store name: "defaultStrategyStore".`,
              "Error object:", error,
              "State passed to onRehydrateStorage:", state, // This is the raw value from storage before parsing/migration
              "Hydrated state (if available):", hydratedState // This is the state *after* potential migration/parsing, if it got that far
            );
          } else {
            // devDebug(
            //   `[defaultStrategyStore] Successfully rehydrated. Hydrated state:`,
            //   hydratedState
            // );
          }
        };
      },
    }
  ),
  shallow
);
